@if (tipoFiltro==='M') {
<div class="row" style="border-top:1px solid #ccc; border-bottom:1px solid #ccc;padding:1em;margin-bottom:1em">
  <div class="col-12">
    <div class="button-container">
      Filtra per:
      @for (cat of listCatArt; track cat) {
      <dx-button stylingMode="contained" [id]="cat.id" [text]="getTitleButton(cat.id,cat.descrizione)"
        [type]="selectedCat === cat.id ? 'success' : 'normal'" width="120" (onClick)="filterByCategory(cat.id)">
      </dx-button>
      }
      <dx-button stylingMode="contained" id="0" [text]="getTitleButton(0,'Tutti')"
        [type]="selectedCat === 0 ? 'success' : 'normal'" width="120" (onClick)="filterByCategory(0)"></dx-button>
    </div>
  </div>
</div>
}

<dx-data-grid #gridArticoliDip [dataSource]="dataSource" [showBorders]="true" [focusedRowEnabled]="false"
  [focusedRowIndex]="0" [columnAutoWidth]="true" [showColumnLines]="true" [showRowLines]="true"
  (onRowUpdating)="onUpdating($event)" [columnHidingEnabled]="false" (onInitNewRow)="onInitNewRow()"
  (onEditingStart)="onEditingStart()" (onRowPrepared)="onRowPrepared($event)"
  (onExporting)="onExporting($event)">
  <!-- <dxo-group-panel [visible]="false"></dxo-group-panel>
  <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>-->

  <dxo-export [enabled]="true"></dxo-export>
  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
  <dxo-filter-row [visible]="!bConsultazione"></dxo-filter-row>

  <dxo-editing mode="row" [allowAdding]="!bConsultazione" [allowUpdating]="!bConsultazione"
    [allowDeleting]="!bConsultazione" [useIcons]="!bConsultazione">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
    <dxo-popup title="Dettaglio" [showTitle]="true" [width]="700" [height]="400">
    </dxo-popup>
    <dxo-form>
      <dxi-item itemType="group" [colCount]="3" [colSpan]="2">
        <dxi-item dataField="idDipendente"></dxi-item>
        <dxi-item dataField="idArticolo"></dxi-item>
        <dxi-item dataField="taglia"></dxi-item>
        <dxi-item dataField="quantita"></dxi-item>
        <dxi-item dataField="note" editorType="dxTextArea" [colSpan]="3" [editorOptions]="{ height: 80 }">
        </dxi-item>
      </dxi-item>
    </dxo-form>
  </dxo-editing>
  @if (!bConsultazione) {
  <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
  }

  @if (bConsultazione) {
  <dxi-column type="buttons" [width]="40">
    <dxi-button hint="Assegna articolo" icon="plus" [visible]="bConsultazione" [onClick]="assegnaArticolo"></dxi-button>
  </dxi-column>
  }
  <dxi-column dataField="idTipoArticolo" caption="Tipologia" width="300" [allowEditing]="bEditing" sortOrder="desc"
    [setCellValue]="setTipoValue">
    <dxo-lookup [dataSource]="listTipiArticoliFiltrati" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="idArticolo" caption="Articoli" width="300" [allowEditing]="bEditing" [sortIndex]="1"
    sortOrder="desc">
    <dxo-lookup [dataSource]="getFilteredArticoli" valueExpr="id" [displayExpr]="getArticoloDisplayExpr"></dxo-lookup>
    <dxi-validation-rule type="required" message="Selezionare l'articolo"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField='idCategoria' caption="Categoria" [allowEditing]="false">
    <dxo-lookup [dataSource]="listCatArt" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>
  <dxi-column dataField="taglia" width="80">

  </dxi-column>

  <dxi-column dataField="quantita" width="80" caption="Quantità" [calculateDisplayValue]="getQuantitaDisplay">

  </dxi-column>
  <dxi-column dataField="maxConsegne" dataType="number">

  </dxi-column>
  <dxi-column dataField="maxConsegneIntervallo" caption="Mesi max consegne" dataType="number">

  </dxi-column>

  <dxi-column dataField="note">
  </dxi-column>

</dx-data-grid>

@if (popupKit) {
  <dx-popup class="popup-kit" [width]="480" [height]="'auto'" [showTitle]="true" title="Gestione Kit"
    [dragEnabled]="false" [showCloseButton]="true" container=".dx-viewport" [(visible)]="popupKit">

    <div class="popup-kit-content">
      <p class="popup-kit-text">
        Vuoi aggiungere automaticamente i componenti del kit?
      </p>

      <div class="popup-kit-actions">
        <dx-button stylingMode="contained" text="Sì" type="success" (onClick)="onConfermaKit()" width="80">
        </dx-button>

        <dx-button stylingMode="contained" text="No" type="danger" (onClick)="onDiniegoKit()" width="80">
        </dx-button>
      </div>
    </div>

  </dx-popup>
  }